// Ícones de traço simples e monocromáticos (03_COMPONENTES.md), extraídos do protótipo aprovado.
const PATHS = {
  overview: <path d="M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-3H4zM14 7h6V4h-6z" />,
  signals: <path d="M3 12h3l2-6 4 12 3-8 2 4h4" />,
  market: <><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="4" /><path d="m12 12 5.5-5.5" /></>,
  opportunities: <><circle cx="12" cy="12" r="8" /><path d="M12 7v10M7 12h10" /></>,
  accounts: <path d="M4 20V9l8-5 8 5v11M8 20v-7h8v7" />,
  moves: <path d="M4 17l5-5 4 3 7-9M15 6h5v5" />,
  sources: <><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1A8 8 0 0 0 15 6l-.3-2.6h-4L10.4 6A8 8 0 0 0 8.8 7l-2.4-1-2 3.4 2 1.5a7 7 0 0 0 0 2l-2 1.6 2 3.4 2.4-1A8 8 0 0 0 10.4 18l.3 2.6h4L15 18a8 8 0 0 0 1.6-1l2.4 1 2-3.4-2-1.5a7 7 0 0 0 .1-1z" /></>,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>,
  bell: <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />,
  expansion: <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />,
  environment: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3" /></>,
  sizing: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5.5" /><circle cx="12" cy="12" r="2" /></>,
  person: <><circle cx="12" cy="8" r="4" /><path d="M5 21c0-4 3-7 7-7s7 3 7 7" /></>,
  chevron: <path d="m7 10 5 5 5-5" />,
  logout: <path d="M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10" />,
  alert: <path d="M12 4 2.5 20h19L12 4zM12 10v4M12 17v.5" />,
  lock: <><rect x="5" y="10" width="14" height="10" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
  inbox: <path d="M4 13h4l2 3h4l2-3h4M4 13l2-8h12l2 8v6H4z" />,
  // IM-XPR-001: navegação da experiência orientada a objetivos.
  today: <path d="M3 11 12 4l9 7v9h-6v-6H9v6H3z" />,
  goal: <path d="M5 21V4h12l-2.5 4L17 12H5" />,
  grid: <path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z" />,
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>{PATHS[name]}</svg>;
}
